import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

// Menú de Reportes: cada reporte en su botón
function BotonesReportes() {
  const { user } = useContext(AuthContext);
  const u = user || {};
  const p = (k) => !!u.rolTiendas && !!u[k];

  const SECCIONES = [
    { section: "Ventas", items: [
      { label: "Resumen de ventas", icon: "fas fa-tachometer-alt", color: "#2563eb", href: "/PosReportesVentas?tab=resumen", desc: "Venta, tickets, formas de pago y ranking de tiendas", enabled: p("posReportes") },
      { label: "Ventas por artículo", icon: "fas fa-list-ol", color: "#10b981", href: "/PosVentasArticulo", desc: "Tickets, piezas, stock y última entrada por modelo", enabled: p("posReportes") },
      { label: "Lo más vendido", icon: "fas fa-trophy", color: "#f59e0b", href: "/PosReportesVentas?tab=top", desc: "Por modelo, línea, talla, color o vendedor", enabled: p("posReportes") },
      { label: "Comparativo", icon: "fas fa-balance-scale", color: "#8b5cf6", href: "/PosReportesVentas?tab=comparativo", desc: "Contra el periodo anterior o el año pasado", enabled: p("posReportes") },
    ]},
    { section: "Inventario", items: [
      { label: "Stock bajo", icon: "fas fa-bell", color: "#dc2626", href: "/PosStockBajo", desc: "Lo que se vende y está por acabarse", enabled: p("posInventario") },
      { label: "Inventario", icon: "fas fa-warehouse", color: "#06b6d4", href: "/PosInventario", desc: "Existencias por talla y color", enabled: p("posInventario") },
      { label: "Faltantes de traspasos", icon: "fas fa-search-minus", color: "#dc2626", href: "/PosFaltantes", desc: "Lo que se envió y no llegó", enabled: p("posReportes") || p("posTraspasos") || p("posRecibir") },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Reportes"
      descripcion="Ventas e inventario de las tiendas · un usuario de tienda ve solo la suya"
      icono="fas fa-chart-line"
      color="#2563eb"
      secciones={SECCIONES}
    />
  );
}

export default BotonesReportes;
